/* KALUI analytics hooks: custom events for the Shopify pixel and AJAX add to cart */
(function(){if(window.__kaluiTrack)return;window.__kaluiTrack=1;
function pub(n,d){try{if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish)Shopify.analytics.publish(n,d)}catch(e){}}
var BL={"house-blend":["house","תערובת הבית"],"friday-morning":["friday","שישי בבוקר"],"galilee":["galil","גליל"],"dugri":["dugri","דוגרי"]};
function setup(){
  document.addEventListener("click",function(e){
    var a=e.target.closest&&e.target.closest("a");if(!a)return;
    var m=(a.pathname||"").match(/\/pages\/([a-z-]+)/);
    if(m&&BL[m[1]]){var list=a.closest("#blendCards")?"home_blends":a.closest("#bagStage")?"hero":a.closest(".bp-others")?"blend_page_more":"other";
      pub("kalui_select_blend",{id:BL[m[1]][0],name:BL[m[1]][1],list:list});return}
    if(a.id==="pickbtn"){var pn=document.getElementById("pname"),tt=document.getElementById("total"),pp=document.querySelectorAll('#people button[aria-pressed="true"]')[0];
      pub("kalui_finder",{plan:pn?pn.textContent:"",cups:tt?tt.textContent:"",people:pp?pp.textContent:""});return}
    var card=a.closest(".plan");if(card)pub("kalui_select_plan",{plan:card.dataset.id||""});
  },true);
  var f=document.getElementById("kform");
  if(f&&window.fetch&&window.FormData){
    f.addEventListener("submit",function(e){
      if(e.defaultPrevented)return;e.preventDefault();
      var btn=f.querySelector("[name=add]");if(btn)btn.disabled=true;
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:"/")+"cart/add.js",{method:"POST",body:new FormData(f),headers:{Accept:"application/json"}})
        .then(function(r){if(!r.ok)throw new Error(r.status);location.href=(window.Shopify&&Shopify.routes?Shopify.routes.root:"/")+"cart"})
        .catch(function(){if(btn)btn.disabled=false;HTMLFormElement.prototype.submit.call(f)});
    });
  }
}
if(document.readyState==="complete")setup();else document.addEventListener("DOMContentLoaded",setup);
})();
